import React from "react";

import { Clickable } from ".";

import styles from "./dots.module.scss";

export const Dots = ({
    slideCount,
    className,
}: {
    slideCount: number;
    className?: string;
}) => (
    <div className={className ?? styles.dotsWrapper}>
        {Array.from({ length: slideCount }, (_, i) => (
            <Clickable key={i} slot={`slide-${i}`} className={styles.dot} />
        ))}
    </div>
);
